import { Component, Input } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { TournamentDetailsService } from 'src/app/services/tournaments/tournament-details.service';
import { Tournament, TournamentPoints } from 'src/app/services/tournaments/tournaments.models';
import { BasePageComponent } from '../../base-page/base-page.component';

@Component({
  selector: 'app-tournament-points',
  templateUrl: './tournament-points.component.html',
  styleUrls: ['./tournament-points.component.scss']
})
export class TournamentPointsComponent extends BasePageComponent {

  constructor(
    protected tournamentDetailsService: TournamentDetailsService
  ) { super() }

  @Input() tournament: Tournament;
  points: TournamentPoints[];
  betMultiplier = $localize`:@@betMultiplier:bet multiplier`;
  getDetails() {
    this.tournamentDetailsService.getTournamentPoints(this.tournament.cmsId).pipe(
      takeUntil(this.unsubscribe)
    ).subscribe(resp => {
      this.points = resp;
    })
  }

  ngOnInit(): void {
    this.getDetails();
  }

}
